<template>
  <MainLayout>
    <div id="subTop" class="topimg01" v-if="expDiv === 'child'">
      <div class="container">
        <h2>
          <strong>어린이체험관</strong>
          <span>놀이를 통해 다양한 직업을 체험하는 직업테마 놀이공간</span>
        </h2>
        <ul class="position">
          <li><router-link to="/">홈</router-link></li>
          <li>
            <router-link :to="'/' + currentRouteType">{{ pgName }}</router-link>
          </li>
          <li>어린이체험관　　　<b>당일 예약 가능</b> (오후 2시부터는 현장 발권)</li>
        </ul>
      </div>
    </div>
    <div id="subTop" class="topimg02" v-if="expDiv === 'teen'">
      <div class="container">
        <h2>
          <strong>청소년체험관</strong>
          <span>실제현장과 유사하게 조성된 역할연기방식 직업체험 공간</span>
        </h2>
        <ul class="position">
          <li><router-link to="/">홈</router-link></li>
          <li>
            <router-link :to="'/' + currentRouteType">{{ pgName }}</router-link>
          </li>
          <li>청소년체험관</li>
        </ul>
      </div>
    </div>
    <div id="subTop" class="topimg03" v-if="expDiv === 'skill'">
      <div class="container">
        <h2>
          <strong>숙련기술체험관</strong>
          <span>3대숙련기술을 체험하는 k-skill 체험공간</span>
        </h2>
        <ul class="position">
          <li><router-link to="/">홈</router-link></li>
          <li>
            <router-link :to="'/' + currentRouteType">{{ pgName }}</router-link>
          </li>
          <li>숙련기술체험관</li>
        </ul>
      </div>
    </div>
    <div id="subTop" class="topimg04" v-if="expDiv === 'course'">
      <div class="container">
        <h2>
          <strong>진로설계관</strong>
          <span>직업적성을 찾는 자기검사, 상담설계공간</span>
        </h2>
        <ul class="position">
          <li><router-link to="/">홈</router-link></li>
          <li>
            <router-link :to="'/' + currentRouteType">{{ pgName }}</router-link>
          </li>
          <li>진로설계관</li>
        </ul>
      </div>
    </div>
    <div id="subTop" class="topimg05" v-if="expDiv === 'makive'">
      <div class="container">
        <h2>
          <strong>메카이브</strong>
          <span>창작의 틀을 깨는 자유로운 미래형 만들기 체험관</span>
        </h2>
        <ul class="position">
          <li><router-link to="/">홈</router-link></li>
          <li>
            <router-link :to="'/' + currentRouteType">{{ pgName }}</router-link>
          </li>
          <li>메카이브</li>
        </ul>
      </div>
    </div>
    <div id="subTop" class="topimg06" v-if="expDiv === 'event'">
      <div class="container">
        <h2>
          <strong>이벤트/행사</strong>
          <span>기획공연/교육문화/직업진로</span>
        </h2>
        <ul class="position">
          <li><router-link to="/">홈</router-link></li>
          <li>
            <router-link :to="'/' + currentRouteType">{{ pgName }}</router-link>
          </li>
          <li>이벤트/행사</li>
        </ul>
      </div>
    </div>
    <div id="subTop" class="topimg07" v-if="expDiv === 'onJob'">
      <div class="container">
        <h2>
          <strong>ONJOB</strong>
          <span>한국잡월드 직업·진로 프로그램</span>
        </h2>
        <ul class="position">
          <li><router-link to="/">홈</router-link></li>
          <li>
            <router-link :to="'/' + currentRouteType">{{ pgName }}</router-link>
          </li>
          <li>ONJOB</li>
        </ul>
      </div>
    </div>
    <div id="subTop" class="topimg07" v-if="expDiv === 'future'">
      <div class="container">
        <h2>
          <strong>미래직업관</strong>
          <span>청소년을 위한 미래직업 전문체험공간</span>
        </h2>
        <ul class="position">
          <li><router-link to="/">홈</router-link></li>
          <li>
            <router-link :to="'/' + currentRouteType">{{ pgName }}</router-link>
          </li>
          <li>미래직업관</li>
        </ul>
      </div>
    </div>
    <div id="contents">
      <ProductMain />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import ProductMain from '@/components/product/ProductMain.vue';

export default {
  name: 'ProductMainView',
  components: {
    MainLayout,
    ProductMain,
  },
  data() {
    return {
      expDiv: '',
    };
  },
  computed: {
    pgName() {
      return this.currentRouteType === 'ind' ? '개인예약' : '단체예약';
    },
  },
  created() {
    this.expDiv = this.$route.params.expDiv;
    this.$store.dispatch('setProductExpDiv', this.expDiv);
  },
};
</script>
